module.exports = __webpack_public_path__ + "img/vm-materiaux.6f53ea77.png";